export const PLAYER = {
  HEIGHT: 1.7,
  CROUCH_HEIGHT: 1.0,
  WALK_SPEED: 5.0,
  SPRINT_SPEED: 8.0,
  CROUCH_SPEED: 2.5,
  JUMP_FORCE: 8.0,
  GRAVITY: -20.0,
  DEFAULT_HP: 100,
  REGEN_DELAY: 5.0,
  REGEN_RATE: 5,
  MOUSE_SENSITIVITY: 0.002,
  FOV_NORMAL: 75,
  FOV_ADS: 45,
  ADS_SPEED_MULTIPLIER: 0.5,
  // Energy / Stamina system
  MAX_ENERGY: 100,
  ENERGY_DRAIN_RATE: 25,       // per second while sprinting
  ENERGY_REGEN_RATE: 15,       // per second while not sprinting
  ENERGY_REGEN_DELAY: 1.5,     // seconds after sprint before regen starts
  ENERGY_MIN_TO_SPRINT: 10,    // minimum energy to start sprinting
  DASH_DOUBLE_TAP_WINDOW: 0.3, // seconds for W double-tap detection
} as const;

export const FLASHLIGHT = {
  COLOR: 0xffffff,
  INTENSITY: 15.0,
  DISTANCE: 30,
  ANGLE: Math.PI / 4,
  PENUMBRA: 0.4,
  DECAY: 1.0,
  SHADOW_MAP_SIZE: 1024,
} as const;

export const LEVEL = {
  MAX_LEVELS_PER_STAGE: 10,
  MAX_STAGES: 10,
  ZOMBIE_COUNTS: [3, 3, 3, 3, 3, 4, 5, 6, 6, 4],
  HP_MULTIPLIERS: [1.0, 1.1, 1.2, 1.3, 1.5, 1.7, 1.9, 2.1, 2.3, 2.5],
  DAMAGE_MULTIPLIERS: [1.0, 1.05, 1.1, 1.15, 1.2, 1.3, 1.4, 1.5, 1.6, 1.8],
  SPEED_MULTIPLIERS: [1.0, 1.0, 1.05, 1.05, 1.1, 1.1, 1.15, 1.15, 1.2, 1.2],
  CLEAR_BONUS: [50, 50, 50, 100, 100, 100, 150, 150, 150, 300],
} as const;

export const UPGRADE = {
  MAX_LEVEL: 10,
  COSTS: [0, 100, 200, 350, 500, 700, 1000, 1400, 1800, 2500],
  DAMAGE_MULTIPLIERS: [1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 2.0],
  RELOAD_MULTIPLIERS: [1.0, 0.95, 0.90, 0.85, 0.80, 0.75, 0.70, 0.65, 0.60, 0.55],
} as const;

export const RENDER = {
  AMBIENT_INTENSITY: 0.08,
  AMBIENT_COLOR: 0x111122,
  FOG_DENSITY: 0.04,
  FOG_COLOR: 0x000000,
  SHADOW_MAP_SIZE: 2048,
  MAX_PIXEL_RATIO: 2,
} as const;
